"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var player_0_1_0_min_1 = __importDefault(require("../lib/player-0.1.0.min"));
var dutchMonths = [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december",
];
var PlayerForm = (function () {
    function PlayerForm() {
        this.playerForm = document.querySelector("#archivePlayerForm") || null;
        this.fragmentDate = document.querySelector(".fragment-date") || null;
        this.fragmentTime = document.querySelector(".fragment-time") || null;
        this.shareFragmentDate = document.querySelector(".share-fragment-date") || null;
        this.shareFragmentTime = document.querySelector(".share-fragment-time") || null;
        this.shareFragmentText = document.querySelector(".share-fragment-text") || null;
        this.shareButton = document.querySelector(".share-button") || null;
        this.copyButton = document.querySelector(".copy-button") || null;
        this.errorElement = document.querySelector(".error") || null;
        this.shareDialog = document.querySelector(".share-dialog") || null;
        this.shareDialogBackdrop = document.querySelector(".share-dialog-backdrop") || null;
        this.closeDialogButton = document.querySelector(".close-dialog") || null;
        this.iframe = null;
        this.player = null;
        this.minuteThreshold = 15;
        this.urlParameters = "style=artwork&share=0&download=0&description=0&subscribe=0&foreground=ffffff&background=7a7a7a&highlight=ffd200&follow=0";
        this.autoPlay = true;
        this.currentSeconds = 0;
        this.baseUrl = "https://bnr.nl";
        if (!PlayerForm.instance) {
            PlayerForm.instance = this;
            this.init();
        }
        else {
            throw new Error("Error: Instantiation failed: Use PlayerForm.getInstance() instead of new.");
        }
    }
    PlayerForm.getInstance = function () {
        if (!this.instance) {
            this.instance = new PlayerForm();
        }
        return this.instance;
    };
    PlayerForm.prototype.init = function () {
        if (this.playerForm) {
            this.playerForm.addEventListener("submit", this.getFragment.bind(this));
            this.fragmentDate.addEventListener("change", this.onDateTimeChange.bind(this));
            this.fragmentTime.addEventListener("change", this.onDateTimeChange.bind(this));
            this.shareFragmentDate.addEventListener("change", this.setShareUrl.bind(this));
            this.shareFragmentTime.addEventListener("change", this.setShareUrl.bind(this));
            this.shareButton.addEventListener("click", this.openShareDialog.bind(this));
            this.shareDialogBackdrop.addEventListener("click", this.hideShareDialog.bind(this));
            this.closeDialogButton.addEventListener("click", this.hideShareDialog.bind(this));
            this.copyButton.addEventListener("click", this.copyTextToClipboard.bind(this));
            this.setMaxDateTime();
            if (window.location.search) {
                var urlParams = new URLSearchParams(window.location.search);
                if (urlParams.get("date") && urlParams.get("time")) {
                    this.applyUrlParameters(urlParams);
                }
            }
            else {
                this.showGuide();
            }
        }
    };
    PlayerForm.prototype.initPlayer = function (url) {
        var _this = this;
        if (!this.iframe || this.iframe === null) {
            document.querySelector(".share").setAttribute("style", "display: block;");
            this.iframe = document.createElement("iframe");
            this.iframe.src = url;
            this.iframe.setAttribute("allow", "autoplay");
            this.iframe.style.cssText = "width: 100%; height: 180px;";
            document.querySelector(".player").appendChild(this.iframe);
        }
        this.player = new player_0_1_0_min_1.default.Player(this.iframe);
        this.player.on("ready", function () {
            _this.player.on("timeupdate", function (value) {
                _this.currentSeconds = Math.floor(value.seconds) || _this.currentSeconds;
            });
        });
    };
    PlayerForm.prototype.applyUrlParameters = function (urlParams) {
        this.autoPlay = false;
        var _a = urlParams.get("date").split("-"), day = _a[0], month = _a[1], year = _a[2];
        var _b = urlParams.get("time").split("-"), hours = _b[0], minutes = _b[1], seconds = _b[2];
        this.fragmentTime.value = hours + ":" + minutes + ":" + seconds;
        this.fragmentDate.value = year + "-" + month + "-" + day;
        this.shareFragmentTime.value = hours + ":" + minutes + ":" + seconds;
        this.shareFragmentDate.value = year + "-" + month + "-" + day;
        this.currentSeconds = +seconds + +minutes * 60;
        this.selectedDateTime = new Date(year + "-" + month + "-" + day + "T" + hours + ":" + minutes + ":" + seconds);
        document.querySelector(".archive-play-button").click();
        analyticsEvent("gemistForm", "pasted share url: ", year + "-" + month + "-" + day + "T" + hours + ":" + minutes + ":" + seconds, null);
    };
    PlayerForm.prototype.copyTextToClipboard = function () {
        var text = this.shareFragmentText.value;
        if (!navigator.clipboard) {
            return;
        }
        navigator.clipboard.writeText(text).then(function () {
            analyticsEvent("gemistForm", "generate share url success, url: ", text, null);
            document.querySelector(".copy-button").classList.add("success");
            setTimeout(function () {
                document.querySelector(".copy-button").classList.remove("success");
            }, 3000);
        }, function (error) {
            console.info("generate share url failed: ", error.message);
            analyticsEvent("gemistForm", "generate share url failed: ", error.message, null);
            document.querySelector(".copy-button").classList.add("error");
        });
    };
    PlayerForm.prototype.setMaxDateTime = function () {
        var now = new Date();
        if (now.getMinutes() >= this.minuteThreshold) {
            now.setHours(now.getHours(), 0, 0, 0);
        }
        else if (now.getMinutes() < this.minuteThreshold) {
            now.setHours(now.getHours() - 1, 0, 0, 0);
        }
        this.maxTimeInputValue = this.pad(now.getHours()) + ":00:00";
        document.querySelector(".maxTimeMessage span").innerHTML = this.maxTimeInputValue + " uur";
        document.querySelector(".error span").innerHTML = this.maxTimeInputValue + " uur";
        if (!this.fragmentTime.value && !window.location.search) {
            var hours = now.getHours() - 1;
            this.fragmentTime.value = this.pad(hours) + ":00:00";
            this.selectedDateTime = new Date(now.setHours(now.getHours() - 1));
        }
        this.maxDateTime = new Date(now);
    };
    PlayerForm.prototype.openShareDialog = function (e) {
        e.preventDefault();
        document
            .querySelector("html")
            .setAttribute("style", "margin: 0; height: 100%; overflow: hidden;");
        this.shareDialog.setAttribute("style", "display: block;");
        this.shareDialogBackdrop.setAttribute("style", "display: block;");
        var d = this.formatDateTime(this.selectedFragmentDateTime);
        this.shareFragmentDate.value = d.year + "-" + this.pad(d.month + 1) + "-" + this.pad(d.day);
        this.shareFragmentTime.value = d.hours + ":" + this.pad(d.minutes) + ":" + this.pad(d.seconds);
        this.setShareTime();
    };
    PlayerForm.prototype.setShareUrl = function () {
        var d = this.formatDateTime(new Date(this.shareFragmentDate.value + "T" + this.shareFragmentTime.value));
        var shareUrl = this.baseUrl + "/gemist?date=" + this.pad(d.day) + "-" + this.pad(d.month + 1) + "-" + d.year + "&time=" + this.pad(d.hours) + "-" + this.pad(d.minutes) + "-" + this.pad(d.seconds);
        this.shareFragmentText.value = shareUrl;
        this.updateSocialShare(shareUrl, d);
    };
    PlayerForm.prototype.setShareTime = function () {
        var date = new Date(this.shareFragmentDate.value + "T" + this.shareFragmentTime.value);
        date.setMinutes(0);
        date.setSeconds(this.currentSeconds);
        var d = this.formatDateTime(new Date(date));
        this.shareFragmentTime.value = d.hours + ":" + this.pad(d.minutes) + ":" + this.pad(d.seconds);
        this.shareFragmentText.value = this.baseUrl + "/gemist?date=" + this.pad(d.day) + "-" + this.pad(d.month + 1) + "-" + d.year + "&time=" + this.pad(d.hours) + "-" + this.pad(d.minutes) + "-" + this.pad(d.seconds);
        this.setShareUrl();
    };
    PlayerForm.prototype.updateSocialShare = function (newUrl, date) {
        var title = "Luister naar dit fragment van " + date.day + " " + dutchMonths[date.month] + " " + Number(date.hours) + ":" + this.pad(date.minutes) + " uur";
        document
            .querySelectorAll(".article-share-social-icons [data-url]")
            .forEach(function (socialIcon) {
            socialIcon.setAttribute("data-url", newUrl);
            socialIcon.setAttribute("data-title", title);
        });
    };
    PlayerForm.prototype.formatDateTime = function (date) {
        var year = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();
        var hours = this.pad(date.getHours());
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        return {
            year: year,
            month: month,
            day: day,
            hours: hours,
            minutes: minutes,
            seconds: seconds,
        };
    };
    PlayerForm.prototype.hideShareDialog = function () {
        this.shareDialogBackdrop.setAttribute("style", "display: none;");
        this.shareDialog.setAttribute("style", "display: none;");
        document.querySelector("html").removeAttribute("style");
        document.querySelector(".copy-button").classList.remove("success", "error");
    };
    PlayerForm.prototype.getFragment = function (e) {
        e.preventDefault();
        this.selectedFragmentDateTime = this.selectedDateTime;
        var d = this.formatDateTime(this.selectedDateTime);
        this.currentSeconds = +d.seconds + +d.minutes * 60;
        if (this.selectedDateTime > this.maxDateTime ||
            (this.maxTimeInputValue === this.fragmentTime.value &&
                this.isToday(new Date(this.selectedDateTime)))) {
            analyticsEvent("gemistForm", "Error message shown to user", "selected dateTime: " + this.selectedDateTime + " | max dateTime: " + this.maxDateTime, null);
            this.errorElement.classList.remove("hidden");
            return;
        }
        this.errorElement.classList.add("hidden");
        var url = this.buildUrl();
        this.initPlayer(url);
        this.iframe.src = url;
        this.showGuide();
    };
    PlayerForm.prototype.onDateTimeChange = function () {
        this.autoPlay = true;
        var date = this.fragmentDate.value;
        var time = this.fragmentTime.value || "00:00:00";
        this.selectedDateTime = new Date(date + "T" + time);
        this.setMaxDateTime();
    };
    PlayerForm.prototype.isToday = function (date) {
        var today = new Date();
        return (date.getDate() == today.getDate() &&
            date.getMonth() == today.getMonth() &&
            date.getFullYear() == today.getFullYear());
    };
    PlayerForm.prototype.pad = function (value) {
        return ("00" + value).slice(-2);
    };
    PlayerForm.prototype.buildUrl = function () {
        var _a;
        var showImageArtwork = ((_a = document.querySelector(".player")) === null || _a === void 0 ? void 0 : _a.offsetWidth) > 580 ? 1 : 0;
        var d = this.formatDateTime(this.selectedDateTime);
        analyticsEvent("gemistForm", "generate audio url for: ", this.pad(d.day) + "-" + this.pad(d.month + 1) + "-" + d.year + " " + this.pad(d.hours) + ":" + this.pad(d.minutes) + ":" + this.pad(d.seconds) + " | user time: " + new Date(), null);
        return "https://omny.fm/shows/bnr-archief/bnr-archief-" + d.day + "-" + (d.month + 1) + "-" + d.year + "-" + d.hours + "-00/embed?" + this.urlParameters + "&image=" + showImageArtwork + (this.autoPlay ? "&autoplay=1" : "") + "&t=" + d.minutes + "m" + d.seconds + "s";
    };
    PlayerForm.prototype.showGuide = function () {
        return __awaiter(this, void 0, void 0, function () {
            var guide, orderedGuide, guideWithDates, selectedPrograms, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.fetchGuide()];
                    case 1:
                        guide = _a.sent();
                        orderedGuide = this.orderGuide(guide);
                        guideWithDates = this.addDateToPrograms(orderedGuide);
                        selectedPrograms = this.getPrograms(guideWithDates);
                        this.showPrograms(selectedPrograms);
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.log("guide fetch failed");
                        return [2, null];
                    case 3: return [2];
                }
            });
        });
    };
    PlayerForm.prototype.fetchGuide = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dayToSelect, currentDate, dayInMs, dateOffset, req;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dayToSelect = new Date(this.fragmentDate.value).getMilliseconds();
                        currentDate = new Date().getMilliseconds();
                        dayInMs = 3600 * 24 * 1000;
                        dateOffset = Math.ceil((dayToSelect - currentDate) / dayInMs);
                        return [4, fetch("/guide?offsetToday=" + dateOffset + "&rangePrevious=1&rangeNext=1")];
                    case 1:
                        req = _a.sent();
                        return [4, req.json()];
                    case 2: return [2, _a.sent()];
                }
            });
        });
    };
    PlayerForm.prototype.orderGuide = function (guide) {
        var _loop_1 = function (i) {
            var _a;
            var prevTime = "0";
            var nextDayFromIndex = guide.days[i].programs.findIndex(function (el) {
                if (prevTime && el.time < prevTime) {
                    return true;
                }
                prevTime = el.time;
            });
            var moveToNextDay = guide.days[i].programs.splice(nextDayFromIndex);
            (_a = guide.days[i + 1].programs).splice.apply(_a, __spreadArray([0, 0], moveToNextDay, false));
        };
        for (var i = 0; i < 2; i++) {
            _loop_1(i);
        }
        return guide;
    };
    PlayerForm.prototype.addDateToPrograms = function (guide) {
        guide.days.forEach(function (day) {
            day.programs.forEach(function (program) {
                var startDate = new Date();
                var _a = program.time.split(":"), hours = _a[0], minutes = _a[1];
                startDate.setHours(hours, minutes);
                var endDate = new Date(startDate.getTime() + 1000 * 60 * 30 * program.slots);
                var endDateHours = ("0" + endDate.getHours()).slice(-2);
                var endDateMinutes = ("0" + endDate.getMinutes()).slice(-2);
                program.date = day.date + ", " + program.time + " - " + endDateHours + ":" + endDateMinutes;
            });
        });
        return guide;
    };
    PlayerForm.prototype.getPrograms = function (guide) {
        var timeToSelect = this.fragmentTime.value.substring(0, 5);
        var programAfterCurrent = guide.days[1].programs.findIndex(function (el) {
            return el.time > timeToSelect;
        });
        var selectedPrograms = [];
        if (programAfterCurrent === -1) {
            selectedPrograms.push.apply(selectedPrograms, guide.days[1].programs.slice(-2));
            selectedPrograms.push.apply(selectedPrograms, guide.days[2].programs.slice(0, 1));
        }
        else if (programAfterCurrent === 0) {
            selectedPrograms.push.apply(selectedPrograms, guide.days[0].programs.slice(-2));
            selectedPrograms.push.apply(selectedPrograms, guide.days[1].programs.slice(0, 1));
        }
        else if (programAfterCurrent === 1) {
            selectedPrograms.push.apply(selectedPrograms, guide.days[0].programs.slice(-1));
            selectedPrograms.push.apply(selectedPrograms, guide.days[1].programs.slice(0, 2));
        }
        else {
            selectedPrograms.push.apply(selectedPrograms, guide.days[1].programs.slice(programAfterCurrent - 2, programAfterCurrent + 1));
        }
        return selectedPrograms;
    };
    PlayerForm.prototype.showPrograms = function (programsToShow) {
        var listItems = document.querySelectorAll(".programWrapper li");
        listItems.forEach(function (value, key) {
            var programTemplate = "<a href=\"" + programsToShow[key].url + "\">\n                <img src=\"" + programsToShow[key].imagePath + "?fit=crop&crop=faces&auto=format%252ccompress&q=45&w=80&h=80&fm=jpg&cs=tinysrgb\"\n                     " + (programsToShow[key].imagePath || 'style="display:none;"') + "\n                     alt=\"" + programsToShow[key].title + "\" />\n                <p>\n                    <strong>" + programsToShow[key].title + "</strong><br />\n                    " + programsToShow[key].date + "\n                </p>\n            </a>";
            value.innerHTML = programTemplate;
        });
        document.querySelector(".programWrapper").style.display =
            "block";
    };
    return PlayerForm;
}());
exports.default = PlayerForm;
